import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton/inedx";
import "./styles.scss";
import cs from "classnames";

interface ToggleSwitchButtonProps {
  btnList?: any;
  className?: string;
  onChange?: (val: string) => void;
  value: string;
  disabled?: boolean;
}

const ToggleSwitchButton: React.FC<ToggleSwitchButtonProps> = ({
  btnList = ["hours", "minutes"],
  value,
  className = "",
  onChange,
  disabled,
}) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    setActive(value === "hours" ? 0 : 1);
  }, [value]);

  const handleClick = (i) => () => {
    if (onChange) {
      onChange(btnList[i]);
    }
    setActive(i);
  };

  return (
    <div
      className={cs(
        "d-flex align-items-center switch-wrapper",
        {
          [className]: className,
        },
        { ["cursor-not-allowed-all"]: disabled }
      )}
    >
      {btnList.map((btn, i) => (
        <CustomButton
          variant=""
          className={cs("m-1", {
            ["activity-button"]: +active === +i,
          })}
          onClick={handleClick(i)}
        >
          {btn}
        </CustomButton>
      ))}
    </div>
  );
};
export default ToggleSwitchButton;
